import { FormControl } from "@chakra-ui/react";
import { Text } from "@equidefi/ui";
import { useEffect, useState } from "react";
import Select from "react-select";

import { COUNTRY_OPTIONS } from "@equidefi/constants/countries";

export const CountrySelect = ({ selectedCountry, setFieldValue, fieldName, isDisabled }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (selectedCountry != null) {
      const matched = COUNTRY_OPTIONS.find((c) => c.value === selectedCountry);
      if (matched) setSelectedOption(matched);
    }
  }, [selectedCountry]);

  const handleChange = (option) => {
    if (option === null) {
      setFieldValue(fieldName, null);
    } else {
      setFieldValue(fieldName, option.value);
    }
    setSelectedOption(option);
  };

  return (
    <FormControl mb={4} mt={1} p={0}>
      <Text mb={2}>
        Country <span style={{ color: "red" }}>*</span>
      </Text>
      <Select
        placeholder={""}
        label="Select a Country"
        onChange={handleChange}
        isDisabled={isDisabled}
        isClearable={true}
        options={COUNTRY_OPTIONS}
        value={selectedOption}
      />
    </FormControl>
  );
};
